import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';
import { AuthenticationService, TokensService } from '.';
import { Fee } from '../orders/fee';
import { Scan } from '../orders/scan';
import { Util } from '../shared/util/util'

@Injectable()
export class OrderService {

    private apiURL = environment.apiURL;
    private fulfillmentURL = environment.fulfillmentURL + 'orders';
    private fulfillmentURLEvent = environment.apiURL + 'events';
    private fulfillmentURLLabel = environment.apiURL + 'resources';
    private fulfillmentURLDeliveryNotes = environment.fulfillmentURL + 'resources';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {
    }

    hasDeliveryNote(token: string, reference: string) {
        return this.http.get(this.fulfillmentURLDeliveryNotes + '/' + token + '/deliveryNotes/' + reference, {
            
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("no delivery note for order " + reference));
            });
    }

    getDownloadURL(token: string, trackingNumber: string) {
        return this.fulfillmentURLLabel + '/' + token + '/labels/' + trackingNumber + '?mediaType=pdf';
    }

    getDownloadURLNote(token: string, reference: string) {
        return this.fulfillmentURLDeliveryNotes + '/' + token + '/deliveryNotes/' + reference;
    }

    getScans(reference: string) {
        return this.http.get(this.fulfillmentURL + '/' + reference + '/scans', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let scans = res.json();
                return scans;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load scans"));
            });
    }

    addScan(reference: string, scan: Scan) {
        return this.http.put(this.fulfillmentURL + '/' + reference + '/scans', scan, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.text();
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not add scan"));
            });
    }

    resetScan(reference: string, articleRef: string) {
        return this.http.delete(this.fulfillmentURL + '/' + reference + '/scans/' + articleRef + '?storage=' +  this.authenticationService.getStorageName(), {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not reset scans"));
            });
    }

    removeTrackingNumber(trackingNumber: string) {
        return this.http.delete(this.apiURL + 'trackings/' + trackingNumber ,{
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not remove trackingNumber"));
            });
    }

    getTrackingNumbers(reference: string) {
        return this.http.get(this.apiURL + 'trackings?reference=' + reference + '&status=NORMAL&isLabel=true', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let trackingNumbers = res.json();
                return trackingNumbers;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load trackingNumbers of order  " + reference));
            });
    } 

    getOrderEvents(reference: string) {
        return this.http.get(this.fulfillmentURLEvent + '?reference=' + reference, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load events"));
            });
    }     

    getAllFees() {
        return this.http.get(this.fulfillmentURL + '/fees', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let fees = res.json();
                return fees;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load fees"));
            });
    } 

    getFees(reference: string) {
        return this.http.get(this.fulfillmentURL + '/' + reference + '/fees', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let fees = res.json();
                return fees;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load fees of order  " + reference));
            });
    } 

    removeFee(feeId: number) {
        return this.http.delete(this.fulfillmentURL + '/fees/' + feeId, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete fee"));
            });
    } 

    addFee(fee: Fee) {
        return this.http.post(this.fulfillmentURL + '/fees', fee, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not create fee"));
            });
    } 

    addLabelManuall(reference: string, tracking:string, projectId: string) {
        return this.http.post(this.apiURL + 'trackings/' + reference + '/' + tracking + '/' + projectId + '?trackingStatus=NORMAL&isLabel=true&itemType=NORMAL&comment=ManualLabel', null ,{
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not add label"));
            });
    }
    
    addLabel(businessKey: string) {
        return this.http.post(this.apiURL + 'shipping/order/' + businessKey + '/labels', null,{
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not create label"));
            });
    }

    updateStatus(reference: string, status: string) {
        return this.http.post(this.fulfillmentURL + '/' + reference + '/states/' + status + '/' + this.authenticationService.getStorageName(), null ,{
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Util.handleErrorMessage(error);
            });
    }

    getOrder(reference: string) {
        return this.http.get(this.fulfillmentURL + '/' + reference, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let order = res.json();
                return order;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load order " + reference));
            });
    }    

    getOrders(status: string) {
        return this.http.get(this.fulfillmentURL + (status==null ? '' : '?status=' + status), {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let orders = res.json();
                return orders;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load orders"));
            });
    }

    updateShippingOrderPackaging(businessKey: string, request: any[]) {
        return this.http.put(this.apiURL + 'shipping/order/' + businessKey + '/package', request ,{
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not update order packaging"));
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/services/order.service.ts